module.exports = __webpack_public_path__ + "static/media/icons8-menu.3f790bac.svg";